import * as React from 'react';
const ReturnIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.215 6.98a.5.5 0 0 0-1 0v3.309H5.493l2.004-2.004a.5.5 0 0 0-.707-.707l-2.857 2.857a.5.5 0 0 0 .01.716L6.789 14a.5.5 0 1 0 .707-.707L5.493 11.29h10.222a.5.5 0 0 0 .5-.5z"
      fill="currentColor"
    />
  </svg>
);
export default ReturnIcon;
